import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instanceapi from "../../instanceapi";

const initialState = {};

export const storeSalesRequest = createAsyncThunk('sales-request/storeSalesRequest', async(data) => {
    try {
        const response = await instanceapi.post('/sales/marketing/request/store', data).catch((err) => {});
        return response.data;
    } catch (error) {
        
    }
})

const sales_request_m = createSlice({
    name: 'sales-request',
    initialState
})

export default sales_request_m.reducer;